import { ComponentProps, FC, ReactNode } from 'react';
import { Link as MuiLink } from '@mui/material';
import {
  LinkProps as RouterLinkProps,
  Link as RouterLink,
} from 'react-router-dom';
import { Typography } from 'melp-design/components';

interface LinkProps extends RouterLinkProps {
  label: ReactNode;
  typographyProps?: ComponentProps<typeof Typography>;
}

interface LinkAsButtonProps
  extends Omit<
    ComponentProps<typeof MuiLink<'button'>>,
    'component' | 'type' | 'underline' | 'sx'
  > {
  label: ReactNode;
  color?: ComponentProps<typeof Typography>['color'];
}

export const Link: FC<LinkProps> = ({
  label,
  typographyProps,
  ...linkProps
}) => {
  return (
    <MuiLink
      component={RouterLink}
      underline="always"
      sx={{ textUnderlinePosition: 'under' }}
      {...linkProps}
    >
      <Typography {...typographyProps}>{label}</Typography>
    </MuiLink>
  );
};

export const LinkAsButton: FC<LinkAsButtonProps> = ({
  label,
  color,
  ...linkAsButtonProps
}) => {
  return (
    <MuiLink
      component="button"
      type="button"
      underline="always"
      sx={{ textUnderlinePosition: 'under' }}
      {...linkAsButtonProps}
    >
      <Typography
        component="span"
        textAlign="left"
        sx={{ display: 'block' }}
        color={color}
      >
        {label}
      </Typography>
    </MuiLink>
  );
};
